export const PageLast = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.30042 6.63522L16.598 16.0454L7.33389 25.3648" stroke="currentColor" stroke-width="2"/>
<path d="M23 28L23 4" stroke="currentColor" stroke-width="2"/>
</svg>`;
